import { Result, err } from './result';
import { Event } from '@/app/event-stream';
import { Command, Query } from '../common';

export interface StartError {
  code: StartErrorCode;
  details: unknown;
}

export function startError(code: StartErrorCode, details: unknown) {
  return err({ code, details });
}

export type StartErrorCode = 'could-not-connect-to-api' | 'invalid-parameters';
export type FinishError = 'not-started';

export interface TrackingPlugin<TEvent extends Event = Event> {
  details: PluginDetails;
  start(details: TrackingDetails): Promise<Result<true, StartError>>;
  finish(): Promise<Result<true, FinishError>>;
  handleEvent(event: TEvent): Promise<void>;
  execute(command: Command): void
  query<T extends string, TPayload, TResult>(query: Query<T, TPayload, TResult>): Promise<TResult>;
}

export interface PluginDetails {
  name: string;
  priority: number;
  isAvailable(details: TrackingDetails): Promise<boolean>;
}

export interface TrackingDetails {
  courseId: string;
  // aspect: {
  //   aspectId: string
  //   aspectInstanceId: string
  // };
}

export const TrackingPluginSymbol = Symbol.for('TrackingPlugin');
